import { type Env, getMappedEnv } from '../index';

const stagingConfig = {
	atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
	featureGateApiKey: '7df50500-1036-4fcf-ae85-af97d39a2552',
};

type Config = typeof stagingConfig & {
	env: 'local' | 'test' | 'staging' | 'production';
};

type EnvironmentOverrides = { [env in Env]?: Partial<Config> };

const environmentOverrides: EnvironmentOverrides = {
	production: {
		atlassianAccountUrl: 'https://id.atlassian.com',
		featureGateApiKey: 'c2edd581-96af-4e93-9629-ea093862c6b9',
	},
};

export function getConfig(): Config {
	const env = getMappedEnv();

	return {
		env,
		...stagingConfig,
		...environmentOverrides[env],
	};
}
